export const imageHeight = 150;
export const imageWidth = 302;
